module.exports = __webpack_public_path__ + "static/media/logo-white.7f948ac4.png";